<div class="content">

    <div class="text-left mt-5">

        <h3>Register on Optimus</h3> <br><br>

         
        <div style="padding-bottom: 7rem;">
           
            <img style="border-radius: 0.5rem;" src="/assets/images/unnamed-4.png" class="img-fluid" alt="logo">

        </div>


        <h5>Sign up using this link:</h5><br>

        <p><a href="https://dashboard.optimusdrive.ai/auth/register" target="_blank">https://dashboard.optimusdrive.ai/auth/register</a></p>

        
        <img src="/assets/images/signup.png" class="img-thumbnail" alt="register">




       <h5 style="padding-top: 8rem;">After signup and successful email link verifications, sign in using this link:</h5><br>

        <p><a href="https://dashboard.optimusdrive.ai/auth/login" target="_blank">https://dashboard.optimusdrive.ai/auth/login</a></p>


        <img src="/assets/images/signin.png" class="img-thumbnail" alt="login">



        
        <!-- <div style="padding-top: 8rem;">

            <h5>Please see the demo video which shows</h5><br><br>


            <div class="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/5mrzvloiNCU?rel=0" title="YouTube video" allowfullscreen></iframe>
            </div>


        </div> -->
    



  
    

















    </div>
</div>

